/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

export type LeadContactDetailsPreferredChannel = typeof LeadContactDetailsPreferredChannel[keyof typeof LeadContactDetailsPreferredChannel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadContactDetailsPreferredChannel = {
  EMAIL: 'EMAIL',
  WHATSAPP: 'WHATSAPP',
  SMS: 'SMS',
  MOBILE: 'MOBILE',
} as const;
